import memoizeOne from 'memoize-one'
import { round } from 'remeda'

import { toPercent } from '@hap/utils'

import { RangeFilterControl } from './messages'

export function PercentageFilterControl(props: { field?: 'averageEvaluationScore' | 'escalationRiskScore' }) {
  const field = props.field || 'averageEvaluationScore'
  return (
    <RangeFilterControl
      historyKey={field}
      historyFormatter={toPercent}
      valueFormatter={formatToDecimal}
      field={field}
      defaultHistory={[
        { op: 'gte', value: '0.5', field },
        { op: 'gte', value: '0.8', field },
      ]}
    />
  )
}

/**
 * Converts a percentage value (0-100) to its decimal equivalent (0.00-1.00)
 * @param value - Percentage value as string or number
 * @returns Decimal value rounded to 2 decimal places
 */
const formatToDecimal = memoizeOne((value: string | number) => {
  return round(Number(value) / 100, 2)
})
